import Clear from "./Clear";
import Counter from "./Counter";

const initialisedClearControls = [];
// Initialise search field clear buttons
const clearControls = document.querySelectorAll('[data-control="clear"]');
clearControls.forEach((clearBtn) => {
  // Initialise Clear js class with the control and its targets
  initialisedClearControls.push(new Clear({ control: clearBtn }));
});

const initialisedCounterControls = [];
const counterControls = document.querySelectorAll('[data-control="counter"]');
counterControls.forEach((counterItem) => {
  initialisedCounterControls.push(new Counter({ control: counterItem }));
});

/* Capture any form elements and trigger submit button disable and text change on submit */
const formElements = document.querySelectorAll("form");
if (formElements.length) {
  formElements.forEach((form) => {
    const submitButton = form.querySelector(
      `#${form.getAttribute("id")}_submit`
    );
    if (submitButton) {
      form.addEventListener("submit", () => {
        const text = submitButton.getAttribute("data-submitting");
        submitButton.innerHTML = text;
        submitButton.classList.add("disabled");
      });
    }
  });
}
